import { Flex } from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import AppStatus from "src/constants/AppStatus";
import { Subtitle } from "src/atoms/typography";
import FullScreen from "src/atoms/FullScreen";
import LogoAvatar from "src/modules/avatar/components/LogoAvatar";

const stringKeys = {
  signingOut: "splashScreen.signingOut",
  starting: "splashScreen.starting"
};

export default function SplashScreen({ status }) {
  const { t } = useTranslation();

  return (
    <FullScreen position="fixed" ignoreFrame>
      <Flex
        alignItems="center"
        flexDirection="column"
        width="100%"
        height="100%"
      >
        <Flex alignItems="center" flex="1 1 auto">
          <LogoAvatar />
        </Flex>
        {status === AppStatus.INACTIVE_MODE ? null : (
          <Flex mb="25px" alignItems="center">
            <Spinner />
            <Subtitle color="mediumEmphasis" ml="8px">
              {t(stringKeys[status] || stringKeys["starting"])}
            </Subtitle>
          </Flex>
        )}
      </Flex>
    </FullScreen>
  );
}
